import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteStore = async (id: number) => {
	const response = await cmsClient.delete(`/homepage/admin/store/store/${id}/`);

	return response.data;
};

const useDeleteStore = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Store deleted" />, {
			hideProgressBar: true
		});
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-stores"]);
	};

	return useMutation(deleteStore, { onSuccess, onError, onSettled });
};

export default useDeleteStore;
